import { Pipe, PipeTransform } from '@angular/core';
import { TimezoneService } from '../services/timezone.service';

@Pipe({
  name: 'argentinaDateOnly',
  pure: true,
})
export class ArgentinaDateOnlyPipe implements PipeTransform {
  constructor(private timezoneService: TimezoneService) {}

  transform(value: any): string {
    return this.timezoneService.formatToArgentinaDateOnly(value);
  }
}